import { render, staticRenderFns } from "./importCodigos.vue?vue&type=template&id=3944aec1&scoped=true"
import script from "./importCodigos.vue?vue&type=script&lang=js"
export * from "./importCodigos.vue?vue&type=script&lang=js"
import style0 from "./importCodigos.vue?vue&type=style&index=0&id=3944aec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944aec1",
  null
  
)

export default component.exports